<template>
  <div>
    <!--
    <form @submit="addCustomer(name, email, phone, date_of_bird)">
      <h2>Add a New Customer</h2>
      <input v-model="name" placeholder="Name" class="input" required><br>
      <input v-model="email" placeholder="Email" type="email" class="input" required><br>
      <input v-model="phone" placeholder="Phone" type="tel" class="input" required><br>
      <input v-model="date_of_bird" placeholder="Data de Aniversário" class="input" required><br>
      <button type="submit" class="button">Add New Customer</button>
      
    </form>
    -->
    <v-card-title>
      <b>Membros</b>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="users"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.item.name }}</td>
        <td class="text-xs-right">{{ props.item.item.email }}</td>
        <td class="text-xs-right">{{ props.item.item.phone }}</td>
      </template>
      <template v-slot:pageText="props">
        Linhas {{ props.pageStart }} - {{ props.pageStop }} de
        {{ props.itemsLength }}
      </template>
      <!--
      <tr v-for="(customer, idx) in users"  v-bind:key="idx">
          <td>{{customer.item.name}}</td>
          <td>{{customer.item.email}}</td>
          <td>{{customer.item.phone}}</td>
          <td>
            <v-btn fab dark small color="primary">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn fab dark small color="red">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
      </tr>
      -->
    </v-data-table>
  </div>
</template>
<script>
import { getUsers } from "../services/users";

export default {
  name: "CustomerList",
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Lead",
          align: "left",
          sortable: false,
          value: "item.name",
        },
        { text: "E-mail", value: "item.email" },
        { text: "Telefone", value: "item.phone" },
      ],
      users: [],
    };
  },
  methods: {
    async fetchUsers() {
      // getUsers().get()
      //   .then((result) => {
      //     if(result.data) {
      //       this.users = result.data;
      //     }
      //   })
      //   .catch(err => {
      //     console.log('Error: ', err);
      //   })
      this.loading = true;
      getUsers({
        orderBy: { field: "created_at", direction: "asc" },
      }).onSnapshot({ includeMetadataChanges: true }, (res) => {
        const changes = res.docChanges();
        changes.forEach((change) => {
          if (change.type === "added") {
            // const customer_id = change.doc.data().user_id
            this.users.push({
              ...change.doc.data(),
              id: change.doc.id,
            });
            this.loading = false;
          } else {
            this.loading = false;
          }
          // var source = res.metadata.fromCache ? "local cache" : "server";
        });
      });
    },
  },
  mounted() {
    this.fetchUsers();
  },
};
</script>
<style scope></style>
